"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/select-list/examples/default.ts';
var CountryList = _1.SelectList.ofType();
var SelectListExample = /** @class */ (function () {
    function SelectListExample() {
        var _this = this;
        this.selectedItem = examples_1.countries[0];
        this.closeOnSelect = true;
        this.header = false;
        this.footer = false;
        this.loading = false;
        this.renderItem = function (item) { return (0, mithril_1.default)(_1.ListItem, {
            contentRight: (0, mithril_1.default)('', { style: "color:".concat(_1.Colors.BLUE_GREY200) }, item.code),
            label: item.name,
            selected: _this.selectedItem && _this.selectedItem.name === item.name
        }); };
        this.handleSelect = function (item) { return _this.selectedItem = item; };
    }
    SelectListExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(CountryList, {
                closeOnSelect: this.closeOnSelect,
                header: this.header ? (0, mithril_1.default)('h4', 'Header content') : undefined,
                footer: this.footer ? (0, mithril_1.default)('h4[style=margin: 15px 0 0 0]', 'Footer content') : undefined,
                items: examples_1.countries,
                itemRender: this.renderItem,
                itemPredicate: this.itemPredicate,
                onSelect: this.handleSelect,
                loading: this.loading,
                popoverAttrs: {
                    hasArrow: false
                },
                trigger: (0, mithril_1.default)(_1.Button, {
                    align: 'left',
                    compact: true,
                    iconRight: _1.Icons.CHEVRON_DOWN,
                    sublabel: 'Country:',
                    label: this.selectedItem && this.selectedItem.name,
                    style: 'min-width: 300px'
                })
            })
        ]);
    };
    SelectListExample.prototype.itemPredicate = function (query, item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
    };
    SelectListExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnSelect,
                label: 'Close on select',
                onchange: function () { return _this.closeOnSelect = !_this.closeOnSelect; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.header,
                label: 'Header',
                onchange: function () { return _this.header = !_this.header; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.footer,
                label: 'Footer',
                onchange: function () { return _this.footer = !_this.footer; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.loading,
                label: 'Loading',
                onchange: function () { return _this.loading = !_this.loading; }
            })
        ];
    };
    return SelectListExample;
}());
exports.SelectListExample = SelectListExample;
